import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Evolution from './pages/Evolution';
import About from './pages/About';
import Projects from './pages/Projects';
import PraiseBreakPrivacy from './pages/PraiseBreakPrivacy';
import Contact from './pages/Contact';
import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/projects" element={<Layout><Projects /></Layout>} />
          <Route path="/projects/praisebreak/privacy" element={<Layout><PraiseBreakPrivacy /></Layout>} />
          <Route path="/evolution" element={<Layout><Evolution /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
        </Routes>
      </div>
      <Analytics />
    </Router>
  );
}

export default App;